import * as swcHelpers from '@swc/helpers';
import { sortByDistance } from './sort-by-distance.js';

/**
 * Find the `limit` items that are nearest to the `reference` point on the
 * surface of earth. Returns an array of objects cloned from the original
 * items, with the `distance` in meters added.
 */ const findNearestCoordinates = (reference, items, options = {
    limit: 1
})=>sortByDistance(reference, items).slice(0, options.limit).map(([item, distance])=>swcHelpers.objectSpread({}, item, {
            distance
        })
    )
;

export { findNearestCoordinates };
//# sourceMappingURL=find-nearest-coordinates.js.map
